<template>
    <svg viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_16605_236775)">
            <path
                d="M35.0024 16.8C35.0043 16.531 34.8653 16.2807 34.636 16.14H34.632L34.6176 16.132L22.6976 9.07601C22.6462 9.04124 22.5927 9.00945 22.5376 8.98082C22.0774 8.74337 21.5307 8.74337 21.0704 8.98082C21.0153 9.00947 20.9619 9.04124 20.9104 9.07601L8.99046 16.132L8.97607 16.14C8.61176 16.3666 8.50007 16.8456 8.72662 17.2099C8.79337 17.3172 8.88531 17.4066 8.99446 17.4704L20.9145 24.5264C20.9661 24.5609 21.0195 24.5927 21.0745 24.6216C21.5347 24.8591 22.0814 24.8591 22.5417 24.6216C22.5966 24.5927 22.65 24.5609 22.7017 24.5264L34.6217 17.4704C34.8598 17.3316 35.0052 17.0757 35.0024 16.8Z"
                fill="#0A2767"
            />
            <path
                d="M10.3772 12.0888H18.1996V19.2592H10.3772V12.0888ZM33.3996 4.8V1.51999C33.4184 0.699916 32.7693 0.0196509 31.9492 0H11.65C10.8299 0.0196509 10.1808 0.699916 10.1996 1.51999V4.8L22.1996 7.99999L33.3996 4.8Z"
                fill="#0364B8"
            />
            <path
                d="M10.2031 4.7998H18.2031V11.9998H10.2031V4.7998Z"
                fill="#0078D4"
            />
            <path
                d="M26.2031 4.7998H18.2031V11.9998L26.2031 19.1998H33.4031V11.9998L26.2031 4.7998Z"
                fill="#28A8EA"
            />
            <path d="M18.2031 12H26.2031V19.2H18.2031V12Z" fill="#0078D4" />
            <path
                d="M18.2031 19.2002H26.2031V26.4002H18.2031V19.2002Z"
                fill="#0364B8"
            />
            <path
                d="M10.3789 19.2593H18.2013V25.7777H10.3789V19.2593Z"
                fill="#14447D"
            />
            <path
                d="M26.2031 19.2002H33.4031V26.4002H26.2031V19.2002Z"
                fill="#0078D4"
            />
            <path
                d="M34.6351 17.4262L34.6199 17.4342L22.6999 24.1382C22.6479 24.1702 22.5952 24.2006 22.5399 24.2278C22.3375 24.3242 22.1176 24.3786 21.8935 24.3878L21.2423 24.007C21.1873 23.9794 21.1339 23.9487 21.0823 23.915L9.00236 17.0206H8.99676L8.60156 16.7998V30.371C8.60772 31.2764 9.34651 32.0056 10.252 31.9998H33.3767C33.3903 31.9998 33.4023 31.9934 33.4167 31.9934C33.608 31.9812 33.7965 31.9418 33.9767 31.8766C34.0546 31.8436 34.1298 31.8046 34.2015 31.7598C34.2551 31.7294 34.3471 31.663 34.3471 31.663C34.7569 31.3598 34.9995 30.8808 35.0015 30.371V16.7998C35.0013 17.0594 34.8613 17.2987 34.6351 17.4262Z"
                fill="url(#paint0_linear_16605_236775)"
            />
            <path
                opacity="0.5"
                d="M34.3608 16.7463V17.5783L21.8968 26.1598L8.99278 17.0263C8.99278 17.0218 8.98919 17.0183 8.98477 17.0183L7.80078 16.3063V15.7062L8.28878 15.6982L9.32077 16.2902L9.34476 16.2983L9.43276 16.3543C9.43276 16.3543 21.5607 23.2743 21.5928 23.2902L22.0567 23.5622C22.0967 23.5462 22.1367 23.5302 22.1847 23.5142C22.2088 23.4982 34.2247 16.7382 34.2247 16.7382L34.3608 16.7463Z"
                fill="#0A2767"
            />
            <path
                d="M34.6351 17.4262L34.6199 17.435L22.6999 24.139C22.6479 24.171 22.5951 24.2014 22.5399 24.2286C22.077 24.4547 21.5356 24.4547 21.0727 24.2286C21.0179 24.2014 20.9645 24.1715 20.9127 24.139L8.99276 17.435L8.97837 17.4262C8.74823 17.3014 8.60395 17.0616 8.60156 16.7998V30.371C8.60729 31.2763 9.34582 32.0055 10.2511 31.9998C10.2511 31.9998 10.2511 31.9998 10.2512 31.9998H33.3519C34.2572 32.0056 34.9958 31.2763 35.0015 30.3711C35.0015 30.3711 35.0015 30.371 35.0015 30.371V16.7998C35.0012 17.0594 34.8612 17.2987 34.6351 17.4262Z"
                fill="#1490DF"
            />
            <path
                opacity="0.1"
                d="M22.8734 24.04L22.695 24.14C22.6433 24.173 22.5899 24.2031 22.535 24.2304C22.3385 24.3269 22.1248 24.3835 21.9062 24.3968L26.4414 29.76L34.3526 31.6664C34.5694 31.5027 34.7419 31.2874 34.8543 31.04L22.8734 24.04Z"
                fill="black"
            />
            <path
                opacity="0.05"
                d="M23.6814 23.5854L22.695 24.1398C22.6433 24.1728 22.5899 24.2029 22.535 24.2302C22.3385 24.3267 22.1248 24.3833 21.9062 24.3966L24.031 30.255L34.355 31.6638C34.7617 31.3585 35.0012 30.8796 35.0014 30.371V30.1958L23.6814 23.5854Z"
                fill="black"
            />
            <path
                d="M10.2736 31.9998H33.3495C33.7046 32.0016 34.0509 31.8894 34.3375 31.6798L21.2415 24.0086C21.1865 23.981 21.1331 23.9503 21.0815 23.9166L9.00155 17.0222H8.99595L8.60156 16.7998V30.3246C8.60066 31.2489 9.34924 31.9989 10.2736 31.9998Z"
                fill="#28A8EA"
            />
            <path
                opacity="0.1"
                d="M19.8016 7.8663V24.9303C19.8001 25.5286 19.4363 26.0663 18.8816 26.2903C18.7097 26.3641 18.5246 26.4023 18.3376 26.4023H8.60156V7.1999H10.2016V6.3999H18.3376C19.1458 6.40296 19.7998 7.05809 19.8016 7.8663Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M19.0016 8.66617V25.7301C19.0036 25.9234 18.9626 26.1147 18.8816 26.2901C18.6594 26.8377 18.1285 27.197 17.5376 27.1997H8.60156V7.19977H17.5376C17.7697 7.19745 17.9985 7.25535 18.2016 7.36778C18.692 7.61485 19.0014 8.11705 19.0016 8.66617Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M19.0016 8.66617V24.1302C18.9977 24.938 18.3454 25.5928 17.5376 25.5997H8.60156V7.19977H17.5376C17.7697 7.19745 17.9985 7.25535 18.2016 7.36778C18.692 7.61485 19.0014 8.11705 19.0016 8.66617Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M18.2016 8.66659V24.1306C18.2007 24.9397 17.5466 25.5962 16.7376 25.6002H8.60156V7.2002H16.7375C17.5465 7.20063 18.202 7.85681 18.2015 8.6658C18.2016 8.66606 18.2016 8.66633 18.2016 8.66659Z"
                fill="black"
            />
            <path
                d="M2.06796 7.2002H16.7351C17.545 7.2002 18.2015 7.85673 18.2015 8.66659V23.3338C18.2015 24.1437 17.545 24.8002 16.7351 24.8002H2.06796C1.25808 24.8002 0.601562 24.1436 0.601562 23.3338V8.66659C0.601562 7.85673 1.2581 7.2002 2.06796 7.2002Z"
                fill="url(#paint1_linear_16605_236775)"
            />
            <path
                d="M5.18303 13.3503C5.54445 12.5802 6.12781 11.9358 6.85824 11.4999C7.66714 11.0368 8.58813 10.8059 9.51984 10.8327C10.3834 10.8139 11.2355 11.0328 11.983 11.4654C12.6859 11.8846 13.252 12.4988 13.6126 13.2334C14.0053 14.043 14.2011 14.9339 14.1838 15.8334C14.2029 16.7736 14.0015 17.7051 13.5958 18.5534C13.2266 19.3144 12.6426 19.9504 11.9158 20.383C11.1394 20.8289 10.2557 21.0536 9.36064 21.0326C8.47866 21.0539 7.60779 20.8325 6.84304 20.3926C6.13407 19.9729 5.56087 19.3581 5.19184 18.6214C4.7968 17.8236 4.59875 16.9427 4.61425 16.0526C4.59779 15.1205 4.79223 14.1967 5.18303 13.3503ZM6.96863 17.6942C7.16132 18.181 7.4881 18.6032 7.91103 18.9118C8.3418 19.2129 8.85763 19.3683 9.38302 19.355C9.94254 19.3772 10.4941 19.2165 10.9542 18.8974C11.3718 18.5898 11.69 18.1665 11.8694 17.6798C12.07 17.1364 12.169 16.5607 12.1614 15.9814C12.1676 15.3967 12.0746 14.8151 11.8862 14.2615C11.7199 13.7616 11.4119 13.3208 10.9998 12.9927C10.5512 12.6584 10.0012 12.4889 9.44221 12.5127C8.90544 12.4988 8.37806 12.6553 7.93582 12.9599C7.50574 13.2698 7.17277 13.6957 6.97582 14.1878C6.53894 15.316 6.53667 16.5661 6.96942 17.6958L6.96863 17.6942Z"
                fill="white"
            />
            <path
                d="M26.2031 4.7998H33.4031V11.9998H26.2031V4.7998Z"
                fill="#50D9FF"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_16605_236775"
                x1="21.8016"
                y1="16.7998"
                x2="21.8016"
                y2="31.9998"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#35B8F1" />
                <stop offset="1" stop-color="#28A8EA" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_16605_236775"
                x1="3.65904"
                y1="6.05438"
                x2="15.1441"
                y2="25.946"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#1784D9" />
                <stop offset="0.5" stop-color="#107AD5" />
                <stop offset="1" stop-color="#0A63C9" />
            </linearGradient>
            <clipPath id="clip0_16605_236775">
                <rect
                    width="34.4"
                    height="32"
                    fill="white"
                    transform="translate(0.601562)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
